/**
 * Перечисления, зеркалящие enum-типы базы `arbuz`.
 *
 * ВАЖНО: значения обязаны совпадать с типами в БД посимвольно. Расхождение
 * проявится не при сборке, а при первом INSERT в проде. Совпадение проверяется
 * тестом `enums.test.ts`, который читает `pg_enum` из реальной базы.
 *
 * Источник правды по схеме — `docs/03-data-model.md` и `db/migrations/0000_init.sql`.
 */
/** `arbuz_user_role` */
export const USER_ROLES = ['client', 'courier', 'admin'];
/** `arbuz_order_status` */
export const ORDER_STATUSES = [
    'new',
    'confirmed',
    'assembled',
    'on_the_way',
    'delivered',
    'cancelled',
    'failed',
];
/** `arbuz_payment_method` */
export const PAYMENT_METHODS = ['cash', 'card_transfer'];
/** `arbuz_payment_status` */
export const PAYMENT_STATUSES = [
    'pending',
    'awaiting_confirmation',
    'paid',
    'not_paid',
    'refund_pending',
    'refunded',
];
/** `arbuz_address_source` */
export const ADDRESS_SOURCES = ['telegram', 'map', 'manual'];
/** `arbuz_product_size` */
export const PRODUCT_SIZES = ['s', 'm', 'l'];
/** `arbuz_outbox_status` */
export const OUTBOX_STATUSES = ['pending', 'sent', 'failed'];
/** Языки интерфейса. В БД — колонка `locale` с CHECK, не enum-тип. */
export const LOCALES = ['ru', 'uz'];
/**
 * Соответствие «имя enum-типа в БД → допустимые значения».
 * Используется тестом сверки с `pg_enum`.
 */
export const DB_ENUMS = {
    arbuz_user_role: USER_ROLES,
    arbuz_order_status: ORDER_STATUSES,
    arbuz_payment_method: PAYMENT_METHODS,
    arbuz_payment_status: PAYMENT_STATUSES,
    arbuz_address_source: ADDRESS_SOURCES,
    arbuz_product_size: PRODUCT_SIZES,
    arbuz_outbox_status: OUTBOX_STATUSES,
};
/**
 * Допустимые переходы статуса заказа.
 * Единственный источник правды по автомату — `docs/06-user-flows.md`.
 * Пустой массив означает терминальный статус.
 */
export const ORDER_TRANSITIONS = {
    new: ['confirmed', 'cancelled'],
    confirmed: ['assembled', 'cancelled'],
    assembled: ['on_the_way', 'cancelled'],
    on_the_way: ['delivered', 'failed', 'cancelled'],
    delivered: [],
    cancelled: [],
    failed: [],
};
/** Кто вправе выполнить переход. Проверяется на сервере, не в интерфейсе. */
export const TRANSITION_ACTORS = {
    // Подтверждать вправе и исполнитель: заказ адресован ему лично, и ждать
    // администратора на каждом заказе означало бы упереть маркетплейс в одного
    // человека. Площадка может вернуть модерацию настройкой
    // `order_confirmation_mode = 'admin'` — её проверяет statusService, потому
    // что настройка живёт в БД, а эта матрица общая для сервера и клиента.
    new: { confirmed: ['admin', 'courier'], cancelled: ['client', 'admin'] },
    confirmed: { assembled: ['admin', 'courier'], cancelled: ['client', 'admin'] },
    assembled: { on_the_way: ['admin', 'courier'], cancelled: ['client', 'admin'] },
    // после выезда курьера клиент отменить уже не может — только администратор
    on_the_way: { delivered: ['courier'], failed: ['courier', 'admin'], cancelled: ['admin'] },
    delivered: {},
    cancelled: {},
    failed: {},
};
/** Статусы, при которых заказ занимает место в слоте. */
export const SLOT_OCCUPYING_STATUSES = ORDER_STATUSES.filter((s) => s !== 'cancelled' && s !== 'failed');
/** Терминальные статусы: из них переходов нет. */
export const TERMINAL_STATUSES = ORDER_STATUSES.filter((s) => ORDER_TRANSITIONS[s].length === 0);
/** Причины несостоявшейся доставки. */
export const FAIL_REASONS = [
    'no_answer',
    'wrong_address',
    'client_refused',
    'unreachable',
    'other',
];
export function canTransition(from, to, role) {
    const allowed = TRANSITION_ACTORS[from][to];
    return allowed !== undefined && allowed.includes(role);
}
//# sourceMappingURL=enums.js.map